"use client"
import { FacebookEmbed } from 'react-social-media-embed';
import { InstagramEmbed } from 'react-social-media-embed';

export default function LandingSocial({ processStep }) {
    switch (processStep?.icon) {
        case "fb":
            return <FacebookEmbed style={{width: '100%'}} height={470} url={processStep.link} />;
        case "insta":
            return <InstagramEmbed style={{width: '100%'}} height={470} url={processStep.link} />;
        default:
            return null;
    }
}
